export default __webpack_public_path__ + "static/media/login-bg.bece1015.jpg";